export enum DateColumnOperators {
  BETWEEN = "between",
  AFTER = "after",
  BEFORE = "before",
  EXACT = "exact",
}

export enum NumberColumnOperators {
  BETWEEN = "between",
  SMALLER_THEN = "smaller_then",
  LARGER_THEN = "larger_then",
  EXACT = "exact",
  IN = "in",
}

export enum StringColumnOperators {
  STARTS_WITH = "starts_with",
  ENDS_WITH = "ends_with",
  CONTAINS = "contains",
  EXACT = "exact",
  IN = "in",
}

export enum BooleanColumnOperators {
  BOOLEAN = "boolean",
}

export enum ArrayColumnOperators {
  CONTAINS_ANY = "contains_any",
}

export enum CommonColumnOperators {
  VALUE_EXISTS = "value_exists",
}
